import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Modal,
  Grid,
} from "@mui/material";
import Swal from "sweetalert2";
import ClearIcon from "@mui/icons-material/Clear";
import { getTorForms } from "../Service";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import BtnUpdFileIcon from "../../img/UploadFileWhite.png";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { signOut } from "../../utils/signOut";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function DataEntry({ onDataEntry, onCancel, team }) {
  const [t, i18n] = useTranslation("global");

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };

  const [errorMsg, setErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);

  // Snack Bar
  const vertical = "top";
  const horizontal = "right";
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  React.useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    // Get TOR form list
    getTorForms().then((res) => {
      if (res && res.status === 200) {
        setTorFormList(res.data);
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: res.data.message,
          text: res.data.error,
          customClass: {
            container: "my-swal-container",
          },
        });
      }
      setLoading(false);
    });
  };

  const logoOptions = [
    {
      id: "1",
      value: "logistic",
      label: "Logistic",
    },
    {
      id: "2",
      value: "industrial",
      label: "Industrial",
    },
  ];

  const handleClearTorClick = () => {
    setTorInput("");
    setErrTor(false);
  };
  const handleClearLogoClick = () => {
    setLogoInput("");
    setErrLogo(false);
  };

  const [torFormList, setTorFormList] = useState([]);
  const [projectInput, setProjectInput] = useState("");
  const [clientInput, setClientInput] = useState("");
  const [workTitleInput, setWorkTitleInput] = useState("");
  const [torInput, setTorInput] = useState("");
  const [logoInput, setLogoInput] = useState("");
  const [errTextProject, setErrTextProject] = useState("");
  const [errTextClient, setErrTextClient] = useState("");
  const [errTextWorkTitle, setErrTextWorkTitle] = useState("");
  const [errTextTor, setErrTextTor] = useState("");
  const [errTextLogo, setErrTextLogo] = useState("");
  const [errProject, setErrProject] = useState(false);
  const [errClient, setErrClient] = useState(false);
  const [errWorkTitle, setErrWorkTitle] = useState(false);
  const [errTor, setErrTor] = useState(false);
  const [errLogo, setErrLogo] = useState(false);

  const teamLogo = () => {
    if (team === "lbd" || team === "lbm-id") {
      return logoInput;
    } else if (team === "lbm-lg") {
      return "logistic";
    } else if (team === "ied") {
      return "industrial";
    } else if (team === "up-power" || team === "up-water") {
      return "utility";
    } else if (team === "moblx") {
      return "group";
    } else {
      return null;
    }
  };

  const [dataEntry, setDataEntry] = useState({});
  const [loadingBtnExport, setLoadingBtnExport] = useState(false);
  const handleClickExport = () => {
    // console.log("Form submitted!");
    if (logoInput.length === 0 && (team === "lbd" || team === "lbm-id")) {
      setErrLogo(true);
      setErrTextLogo("Logo is required!");
      return;
    } else if (projectInput.length === 0) {
      setErrProject(true);
      // setErrTextProject("Project is required!");
      setErrTextProject("Location is required!");
      return;
    } else if (clientInput.length === 0) {
      setErrClient(true);
      setErrTextClient("Client is required!");
      return;
    } else if (workTitleInput.length === 0) {
      setErrWorkTitle(true);
      setErrTextWorkTitle("Work Title is required!");
      return;
    } else if (torInput.length === 0 && team !== "lbd") {
      setErrTor(true);
      setErrTextTor("TOR is required!");
      return;
    }

    const logo = teamLogo();

    // Set data input
    const data = {
      project: projectInput,
      client: clientInput,
      title: workTitleInput,
      tor: torInput ? torInput : null,
      logo: logo,
    };
    setDataEntry(data);
    handleOpenConfirmExport();
  };
  // Export boq
  const [openConfirmExport, setOpenConfirmExport] = useState(false);
  const handleOpenConfirmExport = () => {
    setLoadingBtnExport(false);
    setOpenConfirmExport(true);
  };
  const handleCloseConfirmExport = () => {
    setOpenConfirmExport(false);
    setErrorMsg("");
  };
  const handleClickModalExport = () => {
    // Must change to backdrop loading.. instead button loading
    onDataEntry(dataEntry);
  };

  return (
    <Box>
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={t("common.message.copy")}
      />

      {/*  ////////////////////////// Data Entry Box ////////////////////////// */}

      <Grid container spacing={2} mb={2}>
        {team === "lbd" || team === "lbm-id" ? (
          <>
            <Grid item xs={12} sm={4} md={4} lg={3} alignContent={"start"}>
              <Typography>
                {t("genboq.modal.dataentry.txtbox.logo")}
                <span style={{ color: "red" }}>*</span>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={9}>
              <TextField
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderColor: "white",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                }}
                size="small"
                fullWidth
                select
                required
                value={logoInput}
                error={errLogo}
                onChange={(e) => {
                  setLogoInput(e.target.value);
                  if (e.target.value) {
                    setErrTextLogo("");
                    setErrLogo(false);
                  }
                }}
                helperText={errLogo ? errTextLogo : ""}
                InputProps={{
                  style: {
                    borderRadius: "10px",
                    backgroundColor: "#F0F0F0",
                    fontSize: "medium",
                  },
                  endAdornment: (
                    <IconButton
                      sx={{
                        visibility: logoInput ? "visible" : "hidden",
                      }}
                      onClick={handleClearLogoClick}
                    >
                      <ClearIcon />
                    </IconButton>
                  ),
                }}
              >
                {logoOptions.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </>
        ) : (
          <></>
        )}
        <Grid item xs={12} sm={4} md={4} lg={3} alignContent={"start"}>
          <Typography>
            {t("genboq.modal.dataentry.txtbox.project")}
            <span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={8} lg={9}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "white",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
            }}
            size="small"
            variant="outlined"
            InputProps={{
              style: {
                borderRadius: "10px",
                backgroundColor: "#F0F0F0",
                fontSize: "medium",
              },
            }}
            fullWidth
            required
            value={projectInput}
            error={errProject}
            onChange={(e) => {
              setProjectInput(e.target.value);
              if (e.target.value) {
                setErrTextProject("");
                setErrProject(false);
              }
            }}
            helperText={errTextProject}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={3} alignContent={"start"}>
          <Typography>
            {t("genboq.modal.dataentry.txtbox.client")}
            <span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={8} lg={9}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "white",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
            }}
            size="small"
            variant="outlined"
            InputProps={{
              style: {
                borderRadius: "10px",
                backgroundColor: "#F0F0F0",
                fontSize: "medium",
              },
            }}
            fullWidth
            required
            value={clientInput}
            error={errClient}
            onChange={(e) => {
              setClientInput(e.target.value);
              if (e.target.value) {
                setErrTextClient("");
                setErrClient(false);
              }
            }}
            helperText={errTextClient}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={3} alignContent={"start"}>
          <Typography>
            {t("genboq.modal.dataentry.txtbox.worktitle")}
            <span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={8} lg={9}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "white",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white",
              },
            }}
            size="small"
            variant="outlined"
            InputProps={{
              style: {
                borderRadius: "10px",
                backgroundColor: "#F0F0F0",
                fontSize: "medium",
              },
            }}
            fullWidth
            required
            value={workTitleInput}
            error={errWorkTitle}
            onChange={(e) => {
              setWorkTitleInput(e.target.value);
              if (e.target.value) {
                setErrTextWorkTitle("");
                setErrWorkTitle(false);
              }
            }}
            helperText={errTextWorkTitle}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={3} alignContent={"start"}>
          <Typography>
            {t("genboq.modal.dataentry.txtbox.tor")}
            {team === "lbd" ? "" : <span style={{ color: "red" }}>*</span>}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={8} lg={9}>
          {loading ? (
            <CircularProgress color="inherit" />
          ) : (
            <>
              <Box component="form" noValidate autoComplete="off">
                <TextField
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderColor: "white",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                  }}
                  size="small"
                  fullWidth
                  select
                  required
                  value={torInput}
                  error={errTor}
                  onChange={(e) => {
                    setTorInput(e.target.value);
                    if (e.target.value) {
                      setErrTextTor("");
                      setErrTor(false);
                    }
                  }}
                  helperText={errTor ? errTextTor : torInput}
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                      backgroundColor: "#F0F0F0",
                      fontSize: "medium",
                    },
                    endAdornment: (
                      <IconButton
                        sx={{
                          visibility: torInput ? "visible" : "hidden",
                        }}
                        onClick={handleClearTorClick}
                      >
                        <ClearIcon />
                      </IconButton>
                    ),
                  }}
                >
                  {torFormList.map((form, index) => (
                    <MenuItem key={index} value={form.file_name}>
                      {form.description}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </>
          )}
        </Grid>
      </Grid>

      <Box
        style={{
          display: "flex",
          justifyContent: "end",
          marginTop: "2rem",
        }}
      >
        <LoadingButton
          onClick={handleClickExport}
          loading={loadingBtnExport}
          loadingPosition="start"
          startIcon={<img src={BtnUpdFileIcon} style={styles.BtnIcon} />}
          variant="contained"
          size="small"
          disabled={torFormList.length === 0 ? true : false}
        >
          {/* <span>Export</span> */}
          <span>{t("common.button.export")}</span>
        </LoadingButton>
        <Button
          style={{ marginLeft: 12 }}
          variant="outlined"
          size="middle"
          color="inherit"
          onClick={() => {
            onCancel(true);
          }}
        >
          <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
        </Button>
      </Box>

      {/* /////////// Modal confirm Export BOQ /////////// */}
      <Modal open={openConfirmExport}>
        <Box sx={style}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {/* Export BOQ */}
              {t("genboq.popup.export.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseConfirmExport}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {/* Do you want to confirm Export BOQ ? */}
            {t("genboq.popup.export.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalExport}
              loading={loadingBtnExport}
              loadingPosition="start"
              startIcon={<img src={BtnUpdFileIcon} style={styles.BtnIcon} />}
              variant="contained"
              size="small"
            >
              {/* <span>Export</span> */}
              <span>{t("common.button.export")}</span>
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="middle"
              color="inherit"
              onClick={handleCloseConfirmExport}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
